import React from 'react';
import { Box, Button, Typography, Paper, Stack } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { useNavigate } from 'react-router-dom';

const LockedFeature = ({ featureName, upgradeText, buttonText = 'Upgrade Now' }) => {
    const navigate = useNavigate();

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="50vh"
            textAlign="center"
            p={3}
            bgcolor="background.paper"
        >
            <Paper
                elevation={3}
                sx={{
                    p: 4,
                    maxWidth: 500,
                    width: '100%',
                    borderRadius: 2,
                    backgroundColor: 'white',
                    border: '1px solid #e0e0e0',
                }}
            >
                <Box position="relative" display="inline-block" mb={2}>
                    <LockIcon
                        sx={{
                            fontSize: 64,
                            color: 'warning.main',
                        }}
                    />
                    <EmojiEventsIcon 
                        sx={{
                            position: 'absolute',
                            right: -10,
                            top: -5,
                            color: 'gold',
                            fontSize: 32,
                            filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.2))',
                        }}
                    />
                </Box>
                <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: 'text.primary', mb: 2 }}>
                    {featureName} is a Premium Feature
                </Typography>
                <Typography variant="body1"  paragraph sx={{ mb: 3 }}>
                    This is Invoice Reconciler, a premium feature. {upgradeText || 'Upgrade to unlock powerful invoice management capabilities.'}
                </Typography>
               
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate('/subscription-part-two')}
                    sx={{
                        mt: 2,
                        py: 1.5,
                        px: 4,
                        fontWeight: 'bold',
                        backgroundColor: '#FFA000',
                        '&:hover': {
                            backgroundColor: '#FF8F00',
                        },
                    }}
                >
                    {buttonText}
                </Button>
            </Paper>
        </Box>
    );
};

export default LockedFeature;
